<template>
    <div id="lfcometovisit">
        <div class="tos">
           <el-form :inline="true" :model="visitQueryDto" label-width="100px"  class="demo-form-inline">
              <el-form-item label="关键字：">
                 <el-input v-model="visitQueryDto.phone"></el-input>
              </el-form-item>
              <el-form-item label="开始时间：">
               <el-date-picker
                  v-model="visitQueryDto.startDate"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期"
                  align="right"
                  >
               </el-date-picker>
               </el-form-item>
               <el-form-item label="结束时间：">
               <el-date-picker
                  v-model="visitQueryDto.endDate"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期"
                  align="right"
                  >
               </el-date-picker>
               </el-form-item>
              <el-form-item>
                 <el-button type="primary" plain @click="sjhsearchFor()">查询</el-button>
              </el-form-item>
           </el-form>
        </div>
        <div class="tableform">
          <el-table
              :data="tableData"
              border
              stripe
              :cell-style="{'text-align':'center'}"
              :header-cell-style="{'background-color': '#eef1f6','text-align':'center'}"
              style="width: 100%">
              <el-table-column
                 prop="phone"
                 label="手机号码"
                 >
                 <template slot-scope="{row:{ phone }}">
                 {{ phone|| "—" }}
                 </template>
              </el-table-column>
              <el-table-column
                 prop="ipAddress"
                 label="IP地址"
                 >
                 <template slot-scope="{row:{ ipAddress }}">
                 {{ ipAddress|| "—" }}
                 </template>
              </el-table-column>
              <el-table-column
                 prop="ipLocation"
                 label="IP归属地"
                 >
                 <template slot-scope="{row:{ ipLocation }}">
                 {{ ipLocation|| "—" }}
                 </template>
              </el-table-column>
              <el-table-column
                 prop="visitDate"
                 label="访问时间"
                 >
                 <template slot-scope="{row:{ visitDate }}">
                 {{ visitDate|| "—" }}
                 </template>
              </el-table-column>
              <el-table-column
                prop="visitStatus"
                label="回访状态"
                >
                <template slot-scope="scope">
                  <el-switch
                    @change="handleSwitchChange(scope.row, $event)"
                     v-model="scope.row.visitStatus"
                     active-color="#13ce66"
                     inactive-color="#DBDBDB"
                     active-value="1"
                     inactive-value="0">
                  </el-switch>
                  </template>
             </el-table-column>
           </el-table>
           <div class="btnbox">
              <el-pagination
                 @size-change="handleSizeChange"
                 @current-change="handleCurrentChange"
                 :current-page="visitQueryDto.pageNum"
                 :page-sizes="[10, 15, 20]"
                 :page-size="visitQueryDto.pageSize"
                 layout="total, sizes, prev, pager, next, jumper"
                 :total="this.totals">
              </el-pagination>
           </div>
        </div>
    </div>
    </template>
    <script>
       export default {
       name:'lfcometovisit',
       data(){
        return{
           visitQueryDto:{
              pageNum:1,
              pageSize:10,
              phone:null,
              startDate:null,
              endDate:null,
           },
           tableData: [],
           totals:10,
        }
       },
       created(){
         this.getlist(this.visitQueryDto)
       },
       mounted(){
       },
       methods:{
         getlist(visitQueryDto) {
           this.$api.lfjllbqueryPage(visitQueryDto)
           .then((res) => {
                 if (res.data.code == 200) {
                    let data = res.data.data.records
                    data.forEach(element => {
                     element.visitStatus =  element.visitStatus.toString()
                    });
                    this.tableData = data
                    this.totals = res.data.data.total
                } else {
                this.$message.error(res.data.message)
                }
           })
         },
         handleSwitchChange(row, value) {
            this.$api.gxupdateStatus({
               visitId:row.visitId,
               visitStatus:row.visitStatus,
            })
            .then((res) => {
                  if (res.data.code == 200) {
                  this.$message.success(res.data.message)
                  this.getlist(this.visitQueryDto)
                  } else {
                  this.$message.error(res.data.message)
                  }
            })
         },
         sjhsearchFor(){
            this.getlist(this.visitQueryDto)
         },
         handleCurrentChange(val) {
            this.visitQueryDto.pageNum = val
            this.getlist(this.visitQueryDto)
         },
         handleSizeChange(val) {
            this.visitQueryDto.pageSize = val
            this.getlist(this.visitQueryDto)
         },
       }
       }
    </script>
    <style scoped>
 #lfcometovisit {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    background-color: #fff;
    padding:0 0 0 30px;
    box-sizing: border-box;
 }
 .tos {
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    /* background: yellow; */
    margin-bottom: 20px;
    margin-left: -30px;
  }
  .elrow{
    box-sizing: border-box;
    width: 20%;
    margin-top: -6px;
    margin: 0 40px 0 20px;
  }
  .elrowleft{
    width: 80%;
    float: left;
    box-sizing: border-box;
  }
  .elrowleft input{
    border: 2px solid #1b93ed !important;
    border-radius: 0 !important;
    width: 100%;
    -webkit-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #929da5;
    box-sizing: border-box;
    color: #1f3d35;
    font-size: 14px;
    height: 36px;
    line-height: 1;
    outline: none;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  }
  .elrowcontent{
    width: 16.66667%;
    float: left;
    box-sizing: border-box;
  }
  .search-btn {
    height: 36px;
    width: 100px;
    background: #1b93ed;
    border: 2px solid #1b93ed;
    margin: 0;
    padding: 0;
    color: #fff;
    cursor: pointer;
  }
  .right-item {
    margin-left: auto; /* Pushes the item to the right */
  }
  .tos /deep/ .el-form-item {
      margin-bottom: 0 !important;
  }
  .btnbox {
    /* background: pink; */
    display: flex;
    width: 40%;
    align-items: center;
    justify-content: space-around;
    margin: auto;
    margin-top: 30px;
 }
 .zcyhtk /deep/ .el-form-item__label {
    width: 120px !important;
 }
 .zcyhtk /deep/ .el-form-item__content {
    margin-left: 120px !important;
 }
    </style>


// WEBPACK FOOTER //
// src/components/xtglwxpart/lfcometovisit.vue